// dependencies
import React from "react";
import Button from "Components/Button";
import Spinner from "Components/Spinner";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getCurrentEnvironment } from "../../../../Selectors/app";
import request from "../../../../Api/request";

// css
import css from "./CSMControls.styl";
import { getEmailToken, approveEmailChange } from "../../../../Api/services/emailUpdates";

const CSMControls = (props) => {
	const dispatch = useDispatch();
	const { customerID } = props;

	const env = useSelector(getCurrentEnvironment);

	const query = useQuery({
		queryKey: ["get-email-token", env.name, customerID],
		queryFn: () => getEmailToken(env.name, customerID),
	});

	const mutation = useMutation({
		mutationFn: approveEmailChange,
		onSuccess: () => {
			query.refetch();
			dispatch({ type: "[100] create info toast", message: "Email Change Approved." });
		},
	});

	const handleApprove = async () => {
		await mutation.mutateAsync({
			env: env.name,
			data: {
				token: query.data.emailToken,
				user_id: customerID,
				updated_email: query.data.updatedEmail,
			},
		});
	};

	if (!query?.data?.emailToken || query.isLoading) {
		return null;
	}

	return (
		<div className={css.main}>
			Change Email Pending:
			<div>
				<div className={css.controlNoHover}>{<div>{query.data.updatedEmail}</div>}</div>
				<Button isRequesting={mutation.isLoading} onClick={handleApprove}>
					Approve
				</Button>
			</div>
		</div>
	);
};

CSMControls.propTypes = {
	customerID: PropTypes.string.isRequired,
};

export default CSMControls;
